import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';

const StyledDepTypography = styled.div<Partial<Props>>`
  margin: 0;
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ weight }) => weight};
  color: ${({ color }) => color};
  text-align: ${({ align }) => align};
  line-height: ${({ lineHeight }) => lineHeight};
  @media screen and (max-width: 640px) {
    font-size: ${({ mobileFontSize }) => mobileFontSize};
    font-weight: ${({ mobileWeight }) => mobileWeight};
    color: ${({ color }) => color};
    text-align: ${({ mobileAlign }) => mobileAlign};
    line-height: ${({ mobileLineHeight }) => mobileLineHeight};
  }
`;

type Props = {
  tag?: any;
  fontSize?: string;
  mobileFontSize?: string;
  weight?: any;
  mobileWeight?: any;
  color?: string;
  align?: 'left' | 'center' | 'right';
  mobileAlign?: 'left' | 'center' | 'right';
  lineHeight?: string;
  mobileLineHeight?: string;
  children: any;
};

const RetTypography = ({
  tag = 'div',
  fontSize = '0.875rem',
  mobileFontSize,
  weight = 'normal',
  mobileWeight,
  color = (theme as any).colors.text,
  align = 'left',
  mobileAlign,
  lineHeight = '100%',
  mobileLineHeight,
  children,
  ...rest
}: Props & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <StyledDepTypography
      as={tag}
      {...rest}
      color={color}
      weight={weight}
      mobileWeight={mobileWeight || weight}
      align={align}
      mobileAlign={mobileAlign || align}
      lineHeight={lineHeight}
      mobileLineHeight={mobileLineHeight || lineHeight}
      fontSize={fontSize}
      mobileFontSize={mobileFontSize || fontSize}
    >
      {children}
    </StyledDepTypography>
  );
};

export default RetTypography;
